import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import LoadingContainer from '../../../../components/Page/LoadingContainer';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import {useSMCErrorHandler} from '../../../../utils/errorUtils';
import {useEditorDimensions} from '../../../../utils/hooks';
import Api from '../../../../api/SMPFetchHelper';
import {addCookie} from '../../../../utils/cookies/cookies';
import SMCIFrame from '../../../../components/Simple/SMCIFrame';
import {currentPortalSelector} from '../../../../store/selectors/user.selectors';

function GatewayLogs({
    gatewayObject,
    currentPortal
}) {
    const { getErrorMessage } = useSMCErrorHandler();
    
    const {editorWidth, editorHeight} = useEditorDimensions();
    const [isPageLoaded, setIsPageLoaded] = useState(false);
    const [smartviewUrl, setSmartviewUrl] = useState(null);
    
    const gatewayId = gatewayObject[GatewayGetSchema.id];

    useEffect(() => {
        Api.getSmartviewDataUrl(
            'logs',
            'gateway',
            gatewayId,
            true,
            null,
            gatewayId,
            window.location.origin
        )
        .then(resp => {
            const respData = resp.data.data;
            const cookies = respData.cookieData;
            const url = respData.iframeSrcURL;
            
            const cookiePath = cookies.path;
            const smeId = cookies.SME_ID;
            const token = cookies.token;

            setSmartviewUrl(url);
            addCookie('SME_ID', smeId, cookiePath);
            addCookie('token', token, cookiePath);
        })
        .catch(e => {
            const errorMessage = getErrorMessage(e);
            alert(errorMessage);
        })
        .finally(() => {
            setIsPageLoaded(true);
        })
    }, [currentPortal, getErrorMessage, gatewayId]);

    return (
        <EditorLayout>
            <LoadingContainer loading={!isPageLoaded}>
            {
                smartviewUrl && (
                    <SMCIFrame
                        style={{ width: editorWidth-260, height: editorHeight-50, border: '0 none' }}
                        src={smartviewUrl}
                        allowPopups
                        allowSameOrigin
                        allowScripts
                        allowDownloads
                    />
                )
            }
            </LoadingContainer>
        </EditorLayout>
    );
}

const mapStateToProps = state => ({
    currentPortal: currentPortalSelector(state)
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(GatewayLogs);